import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormControl } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GlobalSearchService } from 'app/services/globalsearchservice.service';
import { InventoryService } from 'app/services/inventory.service';
import { PrintService } from 'app/services/print.service';
import { debounce } from 'chart.js/helpers';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { MatTooltip } from '@angular/material/tooltip';


@Component({
	selector: 'app-missingimages-no-attr',
	templateUrl: './missingimages-no-attr.component.html',
	styleUrls: ['./missingimages-no-attr.component.scss']
})
export class MissingimagesNoAttrComponent implements OnInit, OnChanges, AfterViewInit{

    @Input() items_input: any = [];
    @Input() loading: any = false;
    @Output() missingimages = new EventEmitter <any> ();

    //form data
    mfgs: any = [];
    categories: any = [];
    productlines: any = [];

    //form control
    searchRef = new UntypedFormControl('');
    mfgRef = new UntypedFormControl([]);
    categoryRef = new UntypedFormControl([]);
    productlineRef = new UntypedFormControl([]);
    discontinuedRef = new UntypedFormControl(false)
    hasimageRef = new UntypedFormControl(true);

    //vars
    config: any = false;
    client: any = false;
    items: any = [];
    items_freeze: any = [];

    itemsloading: any = false;
    categorynames: any = [];
    productlinenames: any = [];
    mfgnames: any = [];

    active: any = false;
    firstaction = false;
    dontallowactive = false;
    color = 'blue';

    //pager
    #pagers
	@ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
	dataSource: MatTableDataSource < any > ;
	dataObs: Observable < any > ;
	items_per_page = [5, 10, 25, 100, 250, 500];
	pagesizedefault = 25;
	files: any = [];


	//flag to remove non CDN image links from an item on new upload
	REMOVE_NON_CDN_ON_UNPLOAD = true;
    
	constructor(private _cdr: ChangeDetectorRef, public inventoryService: InventoryService, private globalSearchService: GlobalSearchService,  private printService: PrintService, private modalService: NgbModal, public fb: FormBuilder) {


	}

	//need to refilter if input completed prior to them opening
	ngAfterViewInit(): void {
		if(this.items_input.length){
			setTimeout(() => {
				this.filterItems();
			}, 500)
		}
	}



	ngOnChanges(changes: SimpleChanges): void {
		if(changes.items_input){
			const input = changes.items_input.currentValue;
			if(input.length){
				let index = 0;
				input.forEach(element => { element.active = false; element.index = index; index++; element.editingimages = false; });
				this.itemsloading = false;
				this.items_freeze = JSON.parse(JSON.stringify(input));            
				this.filterItems();
			}
          
		}
	}


	ngOnInit(): void {
		this.color =this.globalSearchService.getColor();
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.client = r.env.client
		});
		this.setForm();
		this.loadItems();
		this.startListeners();
	}

	startListeners(){
		//dont allow active = dont carry active into next filter set since its a full reset and not just image updates
		this.mfgRef.valueChanges.subscribe((res) => {
			this.dontallowactive = true;
			this.filterItems();
		})

		this.categoryRef.valueChanges.subscribe((res) => {
			this.dontallowactive = true;
			this.filterItems();
		})

		this.productlineRef.valueChanges.subscribe((res) => {
			this.dontallowactive = true;
			this.filterItems();
		})

		this.searchRef.valueChanges.pipe(debounceTime(500), distinctUntilChanged()).subscribe((res) => {
			this.dontallowactive = true;
			this.filterItems()
		})

	}

	toggleDiscontinued(){
		this.discontinuedRef.setValue(!this.discontinuedRef.value);
		this.filterItems();
	}

	toggleImage(){
		this.hasimageRef.setValue(!this.hasimageRef.value);
		this.filterItems();
	}

    @HostListener('document:keydown', ['$event'])
	handleKeyboardEvent(event: KeyboardEvent) {
		if (event.key === 'ArrowLeft') {
			if(this.active.index > 0){
				this.setActive(this.items[this.active.index - 1]);
				if(!this.firstaction){
					this.firstaction = true;
				}
			}
		}
		if (event.key === 'ArrowRight') {
			if(this.active.index < this.items.length - 1){
				this.setActive(this.items[this.active.index + 1]);
				if(!this.firstaction){
					this.firstaction = true;
				}
			}
		}
	}


    setForm(){
    	this.inventoryService.getMfgs().subscribe((res:any) => {
    		if(res.length){
    			this.mfgs = res.map((mfg) => {
    				this.mfgnames[mfg.manufacturer_id] = mfg.name;
    				return { 'view': mfg.name, 'value': mfg.manufacturer_id }
    			});
    		}
    	})
    	this.inventoryService.getItemCategories().subscribe((res: any) => {
    		if(res.length){
    			this.categories = res.map((cat) => {
    				this.categorynames[cat.categoryid] = cat.categorydescription;
    				return { 'view': cat.categorydescription, 'value': cat.categoryid }
    			});
    		}
    	})
    	this.inventoryService.getItemProductlines().subscribe((res: any) => {
    		if(res.length){
    			this.productlines = res.map((line) => {
    				this.productlinenames[line.line_field] = line.line_description;
    				return { 'view': line.line_description, 'value': line.line_field }
    			});
    		}
    	})
    }

    loadItems(){
    	//input found and valid
    	if(this.items_input.length){
    		let index = 0;
    		const res = this.items_input;
    		res.forEach(element => { element.active = false; element.index = index; index++; element.editingimages = false; });
    		this.itemsloading = false;
    		this.items_freeze = JSON.parse(JSON.stringify(res));            
    		this.filterItems();
    		//input sub still going
    	}else if(this.loading){
    		this.itemsloading = true;
    	}else{
    		if(this.itemsloading){
    			this.itemsloading.unsubscribe();
    		}
    		this.itemsloading = this.inventoryService.getImageMangerItems().subscribe((res: any) => {
    			let index = 0;
    			res.forEach(element => { element.active = false; element.index = index; index++; element.editingimages = false; });
                
    			this.itemsloading = false;
    			this.items_freeze = JSON.parse(JSON.stringify(res));            
    			this.filterItems();
    		})
    	}
    }

    setActive(item){
    	if(item == null){
    		this.active = { stockid: '', description: 'No item selected', dummy: true, active: true }
    	}else{
    		const new_index = item.index;
    		this.paginator.pageIndex = Math.floor(new_index / this.paginator.pageSize);
    		this.pageupdate();
    		if(this.active){
    			this.active.active = false;
    		}
    		this.active = item;
    		this.active.active = true;
    	}
        
    }

    pageupdate(){
    	this.paginator.page.emit({
    		pageIndex: this.paginator.pageIndex,
    		pageSize: this.paginator.pageSize,
    		length: this.paginator.length
    	});
    }


    blur(){
    	setTimeout(() => {
    		//if in search bar don't blur paginator
    		if(document.activeElement.id == document.getElementById('itemrec').id){
    			return;
    		}else{
    			document.getElementById('blur').focus();
    		}
    	},300)
    }

    filterItems(){

    	//don't filter until items loaded
    	if(!this.items_freeze.length){
    		return;
    	}

    	//reset page index
    	this.paginator.pageIndex = 0;
    	this.pageupdate();


    	//full fiter changes = dont carry active as theyre prob not updating images at that point
    	if(this.dontallowactive){
    		this.active = {}
    		this.dontallowactive = false;
    	}

    	//filter control values
    	const catids = this.categoryRef.getRawValue().length ? this.categoryRef.getRawValue() : Object.keys(this.categorynames)
    	const mfgids = this.mfgRef.getRawValue().length ? this.mfgRef.getRawValue() : Object.keys(this.mfgnames)
    	const productlineids = this.productlineRef.getRawValue().length ? this.productlineRef.getRawValue() : Object.keys(this.productlinenames);
    	const showDiscontinued = this.discontinuedRef.value == false ? 0 : 1;
    	const missingOnly = this.hasimageRef.value == false ? 0 : 1;

    	//copy original item array
    	let items = JSON.parse(JSON.stringify(this.items_freeze));
        
    	//filter controls - always let active through in case of adding multiples with missing only on - if not it takes it away from them since an image was added
    	let missingcount = 0;
    	items = items.filter((item) => {
    		if(item.image == '' && item.discontinued == 0){
    			missingcount++;
    		}
    		let ismatch = false;
    		if(catids.includes(item.categoryid) && mfgids.includes(item.manufacturer_id) && productlineids.includes(item.lineid) || (item.stockid == this.active.stockid)){
    			if((item.discontinued == 1 && showDiscontinued)  || item.discontinued == 0 || (item.stockid == this.active.stockid)){
    				if((missingOnly && item.image == '') || !missingOnly || (item.stockid == this.active.stockid)){
    					ismatch = true;
    				}
    			}
    		}
    		if(ismatch){
    			return item;
    		}
    	});

    	//secondary filtering for search bar input
    	if (this.searchRef.value.length) {
    		const searches = this.searchRef.value.split(' ');
    		searches.forEach(search_val => {
    			items = items.filter((i) => { return ((i.categoryid + '^^' + this.categorynames[i.categoryid] + '^^' + i.name + '^^' + i.stockid + '^^' + i.description + '^^' + i.lineid + '^^' + this.productlinenames[i.lineid]).toUpperCase()).includes(search_val.toUpperCase()) })
    		});
    	}

    	//refind current active index 
    	this.items = items;
    	if(items.length){
            
    		let index = 0;
    		let new_active_index: any = false;

    		this.items.forEach(element => { 
    			element.index = index; 
    			element.active = false; 

    			if(this.active && element.stockid == this.active.stockid){
    				new_active_index = index;
    			}
    			index++; 
    		});

    		new_active_index ? this.setActive(this.items[new_active_index]) : this.setActive(this.items[0]);
    	}else{
    		this.setActive(null)
    	}

    	this.missingimages.emit(missingcount ?? 0);
    	this.setPagination(items)
    }

    resetFilters(){
    	this.categoryRef.setValue([]);
    	this.mfgRef.setValue([]);
    	this.productlineRef.setValue([]);
    	this.filterItems();
    }



    setPagination(data: any[]) {
    	if(typeof data !== 'object'){
    		data = [];
    	}
		
    	this.dataSource = new MatTableDataSource<any>(data);
    	this.dataSource.paginator = this.paginator;
    	this.dataObs = this.dataSource.connect();
		
    	setTimeout(() => {
    		this._cdr.detectChanges();
    	},200)
    }



    //image drop
    onSelect(event: any) {

    	const uploading = this.active;

    	this.files.push(...event.addedFiles);
    	for (let i = 0; i < this.files.length; i++) {
    		this.readFile(this.files[i]).then(fileContents => {
    			//stuff
    			const upload = {
    				content: fileContents,
    				name: event.addedFiles[0].name,
    				mime: event.addedFiles[0].type,
    				item: uploading.stockid,
    				remove_non_cdn: this.REMOVE_NON_CDN_ON_UNPLOAD
    			}
                
    			this.inventoryService.uploadFile(upload, uploading.stockid).subscribe((result: any) => {
    				if(result.error && result.error.length){
    					//show bad notifcation
    					this.globalSearchService.showNotification(result.error, 'danger', 'bottom', 'left');
    				}else if(result.success){
    					//update active and frozen item
    					this.globalSearchService.showNotification(result.item.stockid + ' Image updated', 'success', 'bottom', 'left');
    					this.updateItemArray(result.item);
    				}else{
    					this.globalSearchService.showNotification('Error', 'danger', 'bottom', 'left');
    				}

    				this.files = [];
				 });

    		});
    	}
    }

    updateItemArray(updated_item){
    	//find item in freeze & update
    	const items = JSON.parse(JSON.stringify(this.items_freeze));
    	items.forEach(i => {
    		if(i.stockid == updated_item.stockid){
    			i.image = updated_item.image;
    			i.images = updated_item.images;
    		}
    	});

    	//check active and update
    	if(this.active.stockid == updated_item.stockid){
    		this.active.image = updated_item.image;
    		this.active.images = updated_item.images;
    	}

    	//recreate freeze & filter
    	this.items_freeze = JSON.parse(JSON.stringify(items));

    	this.filterItems();
    }


    removeMainImage() {
    	const data = {
    		item: this.active,
    		image: this.active.image
    	}

    	this.inventoryService.removeMainImage(data).subscribe(result => {
    		if(result.success){
    			//res : {success, id, image, images}
    			this.files = [];
    			this.updateItemArray(result);
    		}
    	});
    }

    changeMainImage(image){
    	const data = {
    		stockid: this.active.stockid,
    		image: image.image
    	}

    	this.inventoryService.updateMainImage(data).subscribe((result) => {
    		if(result.success){
    			this.globalSearchService.showNotification(result.stockid + ' main image changed', 'success', 'bottom', 'left');
    			this.updateItemArray(result);
    		}
    	})
    }


    onRemove(event: any) {
    	this.files.splice(this.files.indexOf(event), 1);
    }

    private async readFile(file: File): Promise<string | ArrayBuffer> {
    	return new Promise<string | ArrayBuffer>((resolve, reject) => {
		  const reader = new FileReader();

    		reader.onload = e => {
    			return resolve((e.target as FileReader).result);
    		};

    		reader.onerror = e => {
    			console.error(`FileReader failed on file ${file.name}.`);
    			return reject(null);
    		};

    		if (!file) {
    			return reject(null);
    		}
    		reader.readAsDataURL(file);
    	});

    	this.files = [];
    }

    updateMfgFilter(id){
    	if(this.mfgRef.value.includes(id)){
    		if(this.mfgRef.value.length == 1){
    			this.mfgRef.setValue([])
    		}else{
    			const cp = JSON.parse(JSON.stringify(this.mfgRef.value));
    			cp[this.mfgRef.value.indexOf(id)] = null;
    			this.mfgRef.setValue(cp.filter(Boolean));
    		}
    	}else{
    		this.mfgRef.setValue([...this.mfgRef.value, id])
    	}
    }

    updateCategoryFilter(id){
    	if(this.categoryRef.value.includes(id)){
    		if(this.categoryRef.value.length == 1){
    			this.categoryRef.setValue([]);
    		}else{
    			const cp = JSON.parse(JSON.stringify(this.categoryRef.value));
    			cp[this.categoryRef.value.indexOf(id)] = null;
    			this.categoryRef.setValue(cp.filter(Boolean));
    		}
    	}else{
    		this.categoryRef.setValue([...this.categoryRef.value, id])
    	}
        
    }

    updateProdlineFilter(id){
    	if(this.productlineRef.value.includes(id)){
    		if(this.productlineRef.value.length == 1){
    			this.productlineRef.setValue([]);
    		}else{
    			const cp = JSON.parse(JSON.stringify(this.productlineRef.value));
    			cp[this.productlineRef.value.indexOf(id)] = null;
    			this.productlineRef.setValue(cp.filter(Boolean));
    		}
    	}else{
    		this.productlineRef.setValue([...this.productlineRef.value, id])
    	}
        
    }






}
